export default __webpack_public_path__ + "static/media/create_budget_info.609e10e2.svg";